import React, { useEffect } from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import HeaderTwo from '../../components/HeaderTwo';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import ReviewForm from './components/ReviewForm';
import PopularCourse from './components/PopularCourse';
import CourseTag from './components/CourseTag';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/course.js';
import Datas from '../../data/course/slider.json';
// import { courseData } from '../../data/CourseData'; 

function CourseDetails() {
    const { id } = useParams();

    const course = Datas.dataList.find((item) => item.id === id);

    useEffect(() => {
        const courseButton = document.querySelectorAll(".course-button");

        const handleClick = (button) => {
            button.classList.toggle("active");
            const content = button.nextElementSibling;

            if (button.classList.contains("active")) {
                content.className = "course-content show";
                content.style.maxHeight = content.scrollHeight + "px";
            } else {
                content.className = "course-content";
                content.style.maxHeight = "0";
            }
        };

        courseButton.forEach((button) => {
            const listener = () => handleClick(button);
            button._listener = listener;
            button.addEventListener("click", listener);
        });

        return () => {
            courseButton.forEach((button) => {
                if (button._listener) {
                    button.removeEventListener("click", button._listener);
                }
            });
        };
    }, []);

    if (!course) {
        return (
            <div className="main-wrapper course-details-page">
                <HeaderTwo />
                <BreadcrumbBox title="Course Not Found" />
                <div className="text-center py-5">
                    <h3>Course not found</h3>
                </div>
                <FooterTwo />
            </div>
        );
    }

    return (
        <div className="main-wrapper course-details-page">

            <HeaderTwo />

            <BreadcrumbBox title={course.courseTitle} />

            <Styles>
                <section className="course-details-area">
                    <Container>
                        <Row>
                            <Col lg="9" md="8" sm="12">
                                <div className="course-details-top">
                                    <div className="heading">
                                        <h4>{course.courseTitle}</h4>
                                    </div>

                                    <div className="course-top-overview">
                                        <div className="d-flex overviews">
                                            <div className="author">
                                                <img
                                                    src={`/assets/images/${course.authorImg}`}
                                                    alt={course.authorName}
                                                />
                                                <div className="author-name">
                                                    <h6>Author</h6>
                                                    <p>{course.authorName}</p>
                                                </div>
                                            </div>

                                            <div className="category">
                                                <h6>Category</h6>
                                                <p>Professional Course</p>
                                            </div>

                                            <div className="rating">
                                                <h6>Status</h6>
                                                <ul className="list-unstyled list-inline">
                                                    <li className="list-inline-item">(Popular Program)</li>
                                                </ul>
                                            </div>

                                            <div className="price">
                                                <h6>Admission</h6>
                                                <p>{course.price}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="course-details-banner">
                                        <img
                                            src={`/assets/images/${course.imgUrl}`}
                                            alt={course.courseTitle}
                                            className="img-fluid"
                                        />
                                    </div>

                                    <div className="course-tab-list">
                                        <Tab.Container defaultActiveKey="overview">
                                            <Nav className="flex-column">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="overview">Overview</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="curriculum">Curriculum</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="instructor">Instructors</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="review">Reviews</Nav.Link>
                                                </Nav.Item>
                                            </Nav>

                                            <Tab.Content>
                                                <Tab.Pane eventKey="overview" className="overview-tab">
                                                    <div className="course-desc">
                                                        <h5>Course Description</h5>
                                                        <p>{course.courseDesc}</p>
                                                    </div>

                                                    <div className="course-feature">
                                                        <h5>Course Feature</h5>
                                                        <p>
                                                            This program is designed to provide strong academic
                                                            knowledge, practical training, and career-oriented
                                                            learning for students who want to build a successful future.
                                                        </p>
                                                        <ul className="list-unstyled">
                                                            <li>
                                                                <i className="las la-arrow-right"></i> Industry-focused learning with practical exposure
                                                            </li>
                                                            <li>
                                                                <i className="las la-arrow-right"></i> Experienced faculty guidance and structured curriculum
                                                            </li>
                                                            <li>
                                                                <i className="las la-arrow-right"></i> Professional skill development for future opportunities
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div className="course-learn">
                                                        <h5>Learning Outcome</h5>
                                                        <p>
                                                            Students will gain subject knowledge, practical skills,
                                                            confidence, and career readiness through structured learning.
                                                        </p>
                                                        <ul className="list-unstyled">
                                                            <li><i className="fa fa-check"></i> Better conceptual understanding of the subject</li>
                                                            <li><i className="fa fa-check"></i> Practical and professional skill enhancement</li>
                                                            <li><i className="fa fa-check"></i> Improved confidence for higher studies and career growth</li>
                                                            <li><i className="fa fa-check"></i> Real-world exposure through guided training</li>
                                                        </ul>
                                                    </div>

                                                </Tab.Pane>

                                                <Tab.Pane eventKey="curriculum" className="curriculum-tab">
                                                    <div className="course-curriculum">
                                                        <h5>Course Curriculum</h5>
                                                        <p>
                                                            The curriculum of {course.courseTitle} is designed to
                                                            build strong academic understanding along with practical
                                                            knowledge and professional readiness.
                                                        </p>
                                                    </div>

                                                    <div className="course-element">
                                                        <h5>Course Content</h5>

                                                        <div className="course-item">
                                                            <button className="course-button active">
                                                                Part 1: Foundation <span>04 Topics</span>
                                                            </button>
                                                            <div className="course-content show">
                                                                <ul className="list-unstyled">
                                                                    <li>
                                                                        <span className="play-icon"><i className="las la-play"></i> Topic 01</span>
                                                                        <span className="lecture-title">Introduction to the program</span>
                                                                    </li>
                                                                    <li>
                                                                        <span className="play-icon"><i className="las la-play"></i> Topic 02</span>
                                                                        <span className="lecture-title">Core subject fundamentals</span>
                                                                    </li>
                                                                    <li>
                                                                        <span className="play-icon"><i className="las la-play"></i> Topic 03</span>
                                                                        <span className="lecture-title">Practical learning modules</span>
                                                                    </li>
                                                                    <li>
                                                                        <span className="play-icon"><i className="las la-play"></i> Topic 04</span>
                                                                        <span className="lecture-title">Career-oriented training</span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>

                                                        <div className="course-item">
                                                            <button className="course-button active">
                                                                Part 2: Intermediate Learning <span>03 Topics</span>
                                                            </button>
                                                            <div className="course-content show">
                                                                <ul className="list-unstyled">
                                                                    <li>
                                                                        <span className="play-icon"><i className="las la-play"></i> Topic 01</span>
                                                                        <span className="lecture-title">Advanced concepts and applications</span>
                                                                    </li>
                                                                    <li>
                                                                        <span className="play-icon"><i className="las la-play"></i> Topic 02</span>
                                                                        <span className="lecture-title">Case studies and project work</span>
                                                                    </li>
                                                                    <li>
                                                                        <span className="play-icon"><i className="las la-play"></i> Topic 03</span>
                                                                        <span className="lecture-title">Professional development skills</span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tab.Pane>

                                                <Tab.Pane eventKey="instructor" className="instructor-tab">
                                                    <h5>Course Instructor</h5>
                                                    <div className="instructor-item">
                                                        <Row>
                                                            <Col md="4">
                                                                <div className="instructor-img">
                                                                    <img
                                                                        src={`/assets/images/${course.authorImg}`}
                                                                        alt={course.authorName}
                                                                        className="img-fluid"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col md="8">
                                                                <div className="instructor-content">
                                                                    <div className="instructor-box">
                                                                        <div className="top-content d-flex justify-content-between">
                                                                            <div className="instructor-name">
                                                                                <h6>{course.authorName}</h6>
                                                                                <p>Program Instructor</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="instructor-desk">
                                                                            <p>
                                                                                {course.authorName} leads this program with
                                                                                a focus on quality education, practical
                                                                                learning, and student career growth.
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Tab.Pane>

                                                <Tab.Pane eventKey="review" className="review-tab">
                                                    <Row>
                                                        <Col md="12">
                                                            <div className="review-comments">
                                                                <h5>Course Reviews</h5>
                                                                <div className="comment-box d-flex">
                                                                    <div className="comment-image">
                                                                        <img src={`/assets/images/testimonial-1.jpg`} alt="" />
                                                                    </div>
                                                                    <div className="comment-content">
                                                                        <div className="content-title d-flex justify-content-between">
                                                                            <div className="comment-writer">
                                                                                <h6>Student Review</h6>
                                                                                <p>Recent Feedback</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="comment-desc">
                                                                            <p>
                                                                                This course provides useful learning,
                                                                                practical exposure, and strong guidance
                                                                                for future growth.
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="review-form">
                                                                <h5>Submit Review</h5>
                                                                <ReviewForm />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Tab.Container>
                                    </div>
                                </div>
                            </Col>

                            <Col lg="3" md="4" sm="12">
                                <div className="single-details-sidbar">
                                    <Row>
                                        <Col md="12">
                                            <div className="course-details-feature">
                                                <h5 className="title">Course Details</h5>
                                                <ul className="list-unstyled feature-list">
                                                    <li><i className="las la-calendar"></i> Start Date: <span>Admissions Open</span></li>
                                                    <li><i className="las la-clock"></i> Duration: <span>As Per Program</span></li>
                                                    <li><i className="las la-globe"></i> Language: <span>English</span></li>
                                                    <li><i className="las la-sort-amount-up"></i> Skill Level: <span>Beginner to Advanced</span></li>
                                                    <li><i className="las la-graduation-cap"></i> Subject: <span>{course.courseTitle}</span></li>
                                                    <li><i className="las la-book"></i> Programs: <span>{course.authorCourses}</span></li>
                                                    <li><i className="las la-bookmark"></i> Admission: <span>{course.price}</span></li>
                                                    <li><i className="las la-certificate"></i> Certification: <span>Yes</span></li>
                                                </ul>
                                                <a href='/registration'><button type="button" className="enroll-btn">Apply Now</button></a>
                                            </div>
                                        </Col>

                                        <Col md="12">
                                            <PopularCourse />
                                        </Col>

                                        <Col md="12">
                                            <CourseTag />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>

            <FooterTwo />
        </div>
    );
}

export default CourseDetails;